import { Link } from "react-router-dom";
import { Youtube, Facebook, Instagram } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { useContent } from "../context/ContentContext";
import { LOGO_URL } from "../lib/api";

export const Footer = () => {
  const { settings } = useSettings();
  const { content } = useContent();
  const logo = settings.logo_image || LOGO_URL;
  const socials = [
    { key: "youtube", url: content.youtube_url, Icon: Youtube },
    { key: "instagram", url: content.instagram_url, Icon: Instagram },
    { key: "facebook", url: content.facebook_url, Icon: Facebook },
  ];
  return (
  <footer className="bg-zinc-950 border-t border-zinc-800 mt-24" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-4">
          <img src={logo} alt="MTL" className="h-16 w-16 object-contain" />
          <span className="font-display text-2xl tracking-tight leading-none">MONSTER TRUCK<br /><span className="text-[#FF3B30]">LORD</span></span>
        </div>
        <p className="text-zinc-400 text-sm max-w-sm leading-relaxed">{content.footer_tagline}</p>
        <div className="flex gap-3 mt-6">
          {socials.filter((s) => s.url).map(({ key, url, Icon }) => (
            <a key={key} href={url} target="_blank" rel="noreferrer" data-testid={`footer-${key}`} className="h-11 w-11 flex items-center justify-center border border-zinc-700 hover:bg-[#FF3B30] hover:border-[#FF3B30] transition-colors">
              <Icon size={20} />
            </a>
          ))}
        </div>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4">Shop</h4>
        <ul className="space-y-2 text-sm text-zinc-400">
          <li><Link to="/shop?category=shirts" className="hover:text-white transition-colors">Shirts</Link></li>
          <li><Link to="/shop?category=hoodies" className="hover:text-white transition-colors">Hoodies</Link></li>
          <li><Link to="/shop?category=stickers" className="hover:text-white transition-colors">Stickers</Link></li>
          <li><Link to="/shop?category=accessories" className="hover:text-white transition-colors">Accessories</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4">Account</h4>
        <ul className="space-y-2 text-sm text-zinc-400">
          <li><Link to="/login" className="hover:text-white transition-colors">Login</Link></li>
          <li><Link to="/register" className="hover:text-white transition-colors">Create Account</Link></li>
          <li><Link to="/account" className="hover:text-white transition-colors">Order History</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-zinc-800 py-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs text-zinc-600 uppercase tracking-widest">
      <span>© {new Date().getFullYear()} Monster Truck Lord — All Rights Reserved</span>
      <span className="hidden sm:inline text-zinc-700">·</span>
      <Link to="/press" data-testid="footer-press" className="hover:text-white transition-colors">Press &amp; Rebranding</Link>
    </div>
  </footer>
  );
};
